var map = {
	"./Icon24Fill15Decrease.svg": [
		848,
		167
	],
	"./Icon24Fill15Increase.svg": [
		849,
		168
	],
	"./Icon24FillAfisha.svg": [
		874,
		169
	],
	"./Icon24FillArrowBottom.svg": [
		855,
		0
	],
	"./Icon24FillArrowLeft.svg": [
		827,
		2
	],
	"./Icon24FillArrowList.svg": [
		871,
		170
	],
	"./Icon24FillArrowRight.svg": [
		828,
		5
	],
	"./Icon24FillArrowTop.svg": [
		854,
		1
	],
	"./Icon24FillBonuses.svg": [
		877,
		215
	],
	"./Icon24FillBusiness.svg": [
		834,
		171
	],
	"./Icon24FillCalendar.svg": [
		866,
		16
	],
	"./Icon24FillCalories.svg": [
		867,
		172
	],
	"./Icon24FillCertificate.svg": [
		869,
		173
	],
	"./Icon24FillCity.svg": [
		863,
		26
	],
	"./Icon24FillClock.svg": [
		852,
		12
	],
	"./Icon24FillClose.svg": [
		844,
		7
	],
	"./Icon24FillComments.svg": [
		873,
		174
	],
	"./Icon24FillComplexity.svg": [
		878,
		175
	],
	"./Icon24FillDistance.svg": [
		858,
		8
	],
	"./Icon24FillDot.svg": [
		875,
		27
	],
	"./Icon24FillEdit.svg": [
		830,
		4
	],
	"./Icon24FillEmail.svg": [
		831,
		17
	],
	"./Icon24FillExcursion.svg": [
		865,
		28
	],
	"./Icon24FillExit.svg": [
		876,
		29
	],
	"./Icon24FillFacebook.svg": [
		839,
		30
	],
	"./Icon24FillFavorites.svg": [
		850,
		13
	],
	"./Icon24FillInfo.svg": [
		861,
		31
	],
	"./Icon24FillInstagram.svg": [
		838,
		32
	],
	"./Icon24FillInvalid.svg": [
		851,
		33
	],
	"./Icon24FillLanguages.svg": [
		868,
		176
	],
	"./Icon24FillLoading.svg": [
		829,
		18
	],
	"./Icon24FillLocation.svg": [
		864,
		10
	],
	"./Icon24FillMagazine.svg": [
		879,
		216
	],
	"./Icon24FillMinus.svg": [
		880,
		34
	],
	"./Icon24FillOk.svg": [
		836,
		35
	],
	"./Icon24FillOkay.svg": [
		881,
		19
	],
	"./Icon24FillPause.svg": [
		847,
		177
	],
	"./Icon24FillPhone.svg": [
		832,
		20
	],
	"./Icon24FillPhoto.svg": [
		882,
		178
	],
	"./Icon24FillPlay.svg": [
		846,
		21
	],
	"./Icon24FillPlus.svg": [
		870,
		6
	],
	"./Icon24FillPromo.svg": [
		883,
		217
	],
	"./Icon24FillRefresh.svg": [
		872,
		36
	],
	"./Icon24FillSearch.svg": [
		845,
		14
	],
	"./Icon24FillSeasons.svg": [
		860,
		37
	],
	"./Icon24FillSettings.svg": [
		857,
		179
	],
	"./Icon24FillShopping.svg": [
		884,
		218
	],
	"./Icon24FillStar.svg": [
		885,
		219
	],
	"./Icon24FillStop.svg": [
		862,
		180
	],
	"./Icon24FillTelegram.svg": [
		841,
		38
	],
	"./Icon24FillTickets.svg": [
		853,
		181
	],
	"./Icon24FillTiktok.svg": [
		840,
		39
	],
	"./Icon24FillTrash.svg": [
		843,
		3
	],
	"./Icon24FillTravel.svg": [
		886,
		220
	],
	"./Icon24FillUser.svg": [
		887,
		221
	],
	"./Icon24FillVk.svg": [
		835,
		40
	],
	"./Icon24FillWeb.svg": [
		833,
		15
	],
	"./Icon24FillYoutube.svg": [
		837,
		41
	],
	"./Icon24StrokeCheck.svg": [
		856,
		182
	],
	"./Icon24StrokeCheckboxArrow.svg": [
		888,
		183
	],
	"./Icon24StrokeFavorites.svg": [
		842,
		9
	],
	"./Icon36StrokeStar.svg": [
		859,
		184
	],
	"./Icon48FillCircleFacebook.svg": [
		889,
		222
	],
	"./Icon48FillCircleInstagram.svg": [
		890,
		223
	],
	"./Icon48FillCircleOk.svg": [
		891,
		224
	],
	"./Icon48FillCircleTelegram.svg": [
		892,
		225
	],
	"./Icon48FillCircleTiktok.svg": [
		893,
		226
	],
	"./Icon48FillCircleVk.svg": [
		894,
		227
	],
	"./Icon48FillCircleYoutube.svg": [
		895,
		228
	],
	"./LogotypeRosatom.svg": [
		896,
		229
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 423;
module.exports = webpackAsyncContext;